import { Image, Link, publicAssetUrl } from '@wilkins-software/redwood-utils';
import { ChevronRight } from 'react-feather';
import type { BlogPostFrontmatter } from '../../utils/blog-content.util';
import { formatBlogPublishedAt } from '../../utils/format-blog-published-at.util';

type BlogArticleCardProps = {
  post: BlogPostFrontmatter;
};

export function BlogArticleCard({ post }: BlogArticleCardProps) {
  const imageSrc = post.associatedImage
    ? publicAssetUrl(post.associatedImage.replace(/^\//, ''))
    : undefined;
  const formattedPublishedAt = formatBlogPublishedAt(post.publishedAt);

  return (
    <article className="group overflow-hidden rounded-lg border border-slate-200 bg-white transition-[transform,box-shadow] duration-300 ease-out hover:-translate-y-1 hover:shadow-md motion-reduce:transition-none motion-reduce:hover:translate-y-0 motion-reduce:hover:shadow-none">
      <div className="relative h-48 overflow-hidden bg-slate-100">
        {imageSrc ? (
          <Image
            src={imageSrc}
            alt=""
            fill
            sizes="(min-width: 1024px) 30vw, (min-width: 640px) 45vw, 100vw"
            className="size-full object-cover transition-transform duration-500 ease-out group-hover:scale-105 motion-reduce:transition-none motion-reduce:group-hover:scale-100"
          />
        ) : null}
      </div>
      <div className="space-y-3 p-6">
        <div className="space-y-1">
          <time
            dateTime={post.publishedAt}
            className="block text-xs font-medium tracking-wide text-slate-500"
          >
            {formattedPublishedAt}
          </time>
          {post.category ? (
            <span className="text-xs font-bold text-primary uppercase">
              {post.category}
            </span>
          ) : null}
        </div>
        <h3 className="text-xl font-semibold text-gray-900 transition-colors duration-200 ease-out group-hover:text-primary motion-reduce:transition-none">
          {post.title}
        </h3>
        <p className="line-clamp-3 text-sm text-slate-600">
          {post.description}
        </p>
        <Link
          href={`/blog/${post.slug}`}
          className="mt-2 inline-flex items-center gap-1 text-sm font-bold text-primary"
        >
          Read More
          <ChevronRight className="size-4 transition-transform duration-200 ease-out group-hover:translate-x-0.5 motion-reduce:transition-none motion-reduce:group-hover:translate-x-0" />
        </Link>
      </div>
    </article>
  );
}
